<template>
  <div id="modalc-template">
    <div class="modalc-mask">
      <div class="modalc-wrapper">
        <div class="modalc-container">
          <button class="modalc-close-button" @click="$emit('close') & closeGA4Click('click', 'cerrar', 'popup politica de cookies')">X</button>
          <div class="modalc-body-body">
            <slot name="body">
              <Cookies v-if="wichModalC === 'cookies'" name="cookies" />
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "@/components/Cookies";
import tagFunctions from '@/utils/tagFunctions.js'

export default {
  name: "ModalCookies",
  components: {
    Cookies,
  },
  props: {
    wichModalC: {
      type: String,
      default: "none"
    }
  },
  methods: {
    closeGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/modalcookies.scss";
</style>